import axios from 'axios'
const urljoin = require('url-join')
const debug = process.env.NODE_ENV !== 'production'
const debugUrl = 'http://localhost:5000' // ローカル環境接続先
// const baseUrl = 'https://dev-alib-1371494401.ap-northeast-1.elb.amazonaws.com' // EC2環境接続先
const baseUrl = 'https://miotasu.jp'
const axiosObj = axios.create({
  xsrfHeaderName: 'X-CSRF-Token',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json'
})
// 過去の姿
// const axiosObj = axios.create({
//   xsrfHeaderName: 'X-CSRF-Token',
//   withCredentials: true
// })

const onSuccess = (res) => {
  if (debug) console.log(' << ' + JSON.stringify(res.data))
  return Promise.resolve(res)
}

const onError = (res) => {
  console.log(res)
  throw new Error('API error')
}

const accessUrl = (endpoint) => {
  if (debug) return urljoin(debugUrl, endpoint)
  else return urljoin(baseUrl, endpoint)
}

const debugMessage = (type, url, params) => {
  console.log(type + ': ' + url + '\nparams: ' + JSON.stringify(params))
}

const setCSRFHeader = () => {
  // 追加箇所
  axiosObj.defaults.headers.common['Content-Type'] = 'application/json'
  if (sessionStorage.getItem('csrf_token')) {
    axiosObj.defaults.headers.common['X-CSRF-Token'] = JSON.parse(sessionStorage.getItem('csrf_token'))
  }
}

export default {
  get: (url, params) => {
    setCSRFHeader()
    let reqUrl = accessUrl(url)
    if (debug) debugMessage('GET', reqUrl, params)
    return axiosObj.get(reqUrl, {params}, {headers: {'Content-Type': 'application/json'}}).then(onSuccess).catch(onError)
  },
  post: (url, params) => {
    setCSRFHeader()
    let reqUrl = accessUrl(url)
    if (debug) debugMessage('POST', reqUrl, params)
    return axiosObj.post(reqUrl, params, {headers: {'Content-Type': 'application/json'}}).then(onSuccess).catch(onError)
  },
  put: (url, params) => {
    setCSRFHeader()
    let reqUrl = accessUrl(url)
    if (debug) debugMessage('PUT', reqUrl, params)
    return axiosObj.put(reqUrl, params, {headers: {'Content-Type': 'application/json'}}).then(onSuccess).catch(onError)
  },
  delete: (url, params) => {
    setCSRFHeader()
    let reqUrl = accessUrl(url)
    if (debug) debugMessage('DELTE', reqUrl, params)
    return axiosObj.delete(reqUrl, {
      data: params
    }).then(onSuccess).catch(onError)
  }
}



// WEBPACK FOOTER //
// ./src/axios/myAxios.js